import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { FileStorageHeader } from "./components/FileStorageHeader";
import { FileStorageList } from "./components/FileStorageList";
import { Grid, Paper } from "@material-ui/core";
import { DriveEtaRounded } from "@material-ui/icons";
import { FileStorageGrid } from "./components/FileStorageGrid";
import { archiveConstants } from "./contstants/archive.contstants";
import { UnsplashGallery } from "./components/UnsplashGallery";
import { FilesStorageProgressbar } from "./components/FileStorageProgressbar";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  paper: {
    overflow: "hidden",
    height: '100%'
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FileStorage(props) {
  const classes = useStyles();
  const { toggleParent, display } = props;
  return (
    <div>
      <Dialog
        maxWidth="lg"
        fullWidth={true}
        open={true}
        classes={classes}
        onClose={toggleParent}
        style={{ overflow: "hidden" }}
        TransitionComponent={Transition}
      >
        <AppBar className="dark-l3" style={{ position: "static" }}>
          <Toolbar style={{ padding: "0px 8px" }}>
            <FileStorageHeader {...props} />
          </Toolbar>
        </AppBar>
        <div className="storage-container">
          <FileStorageList {...props} /> 
          <div className="wh-100 dark-l1" style={{ overflow: "hidden" }}>
            <FilesStorageProgressbar {...props} />
            {display === archiveConstants.IMAGE || display === archiveConstants.OTHER || display === archiveConstants.FONT ? (
              <FileStorageGrid {...props} />
            ) : null}
            {display === archiveConstants.UNSPLASH ? (
              <UnsplashGallery {...props} />
            ) : null}
          </div>
        </div>
      </Dialog>
    </div>
  );
}
